// Root URL for our domain - should not end with a slash!
let ROOT_URL = "https://colpuno.cirii.org";
// By default, ROOT_URL is not used as is, but set according to the hostname of the server we are on.
// This is to allow vhosts to be used. But for local development, this is fixed at ROOT_URL.
if (!(window.location.hostname.trim().toLowerCase() === 'localhost' || window.location.hostname.trim() === '127.0.0.1')) {
  ROOT_URL = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
}
console.log("ROOT_URL: " + ROOT_URL);

export default {
	// Should be one of: Colpuno/Flybridger
	title: "Colpuno",
	// Should be one of: clpn/flyb
	localPrefix: 'clpn',
	// Should be one of: colpuno/flybridger
	siteMode: 'colpuno',
	// NB: URL prefixes below must not end with a slash!
	baseURL: `${ROOT_URL}/api`,
	storageURL: `${ROOT_URL}/storage`,
	// URL of the logo link
	logoUrl: "https://www.colpuno.com",
};
